import React from 'react';
import { FormControl, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material';
import { fontSize, palette } from '../../../..';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useDispatch } from 'react-redux';
import {
  setRightOperand,
  updateTimeGrain,
} from '../../../../redux/Calculations/CalculationsActions';
import { TFilterType } from '../../../../types/types';
import {
  datePatternCollections,
  datePatternSearchConditionCollections,
} from '../../../FilterUtils/FilterPatternCollection';
import { useViewport } from '@xyflow/react';
interface TimeGrainProps {
  propKey: string;
  conditionFilterId: string;
  filterIdx: number;
  timeGrain: string;
  filterType: TFilterType;
  disabled?: boolean;
}

const TimeGrain = React.memo(
  ({ propKey, conditionFilterId, filterIdx, timeGrain, filterType, disabled }: TimeGrainProps) => {
    const dispatch = useDispatch();
     const { zoom } = useViewport();
    const handleTimeGrainChange = (event: SelectChangeEvent<string>) => {
      if (disabled) return;
      if (timeGrain === 'date') {
        setRightOperand(propKey, conditionFilterId, filterIdx, [], []);
      }
      dispatch(updateTimeGrain(propKey, conditionFilterId, filterIdx, event.target.value));
    };
    const timeGrains =
      filterType === 'Pick List' ? datePatternCollections : datePatternSearchConditionCollections;
    return (
      <FormControl
        fullWidth
        size="small"
        sx={{
          marginBottom: '0.625rem',
          '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
              borderColor: '#2bb9bb',
            },
            '&:hover fieldset': {
              borderColor: '#2bb9bb',
            },
          },
        }}
      >
        <Select
          disabled={disabled}
          sx={{
            height: '1.5rem',
            fontSize: fontSize.large,
            textAlign: 'left',
            '.MuiSelect-icon': {
              fontSize: '18px',
              marginRight: '-0.1rem',
              color: palette.primary.contrastText,
              // right: "3.5px",
            },
          }}
          IconComponent={KeyboardArrowDownIcon}
          value={timeGrain}
          variant="outlined"
          onChange={handleTimeGrainChange}
          MenuProps={{
            slotProps: {
              paper: {
                sx: {
                  transform: `scale(${zoom}) !important`
                }
              }
            },
          }}
        >
          {timeGrains.map((item) => (
            <MenuItem key={item.key} value={item.key} selected={item.key === timeGrain}>
              <Typography
                sx={{
                  width: 'auto',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  fontSize: '12px',
                  lineHeight: '20px',
                }}
              >
                {item.value}
              </Typography>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  },
);

export default TimeGrain;
